import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { ConfigProvider, theme } from 'antd';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<>
		<ConfigProvider
			theme={{
				algorithm: theme.darkAlgorithm,
				components: {
					Button: {
						colorPrimary: '#FCD535',
					},
					Radio: {
						colorPrimary: '#FCD535',
					},
					Checkbox: {
						colorPrimary: '#FCD535',
						colorPrimaryHover: '#FCD535',
					},
					Switch: {
						colorPrimary: '#FCD535',
						colorPrimaryHover: '#FCD535',
					},
				},
			}}
		>
			<Provider store={store}>
				<RouterProvider router={router} />
			</Provider>
		</ConfigProvider>
	</>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
